import { useEffect } from "react";
import Cookies from "js-cookie"; // Ensure you have js-cookie installed for cookie management

const UrlRedirector = () => {
  useEffect(() => {

    const currentPath = window.location.pathname;
    const currentSearch = window.location.search; // Get query parameters
    const base_url = ZhLocalizationRoot.HomeUrl || window.location.origin; // Fallback to window.location.origin

    // Retrieve page slug dynamically from a React component or other source
    const pageSlugElement = document.getElementById("page_slug_dynamically_reactjs");
    const pageSlug = pageSlugElement ? pageSlugElement.getAttribute("data-page-slug") : '';
   
    // Get the country code from cookies
    const active_countries = ["uk", "eu"];
    const total_countries = ["uk", "eu", "Global"];

    const current_active_code = Cookies.get("current_active_code") || '';
    const CountryCodeStatusZhash = Cookies.get("CountryCode_status_zhash") || current_active_code;
    
    //console.log("current_active_code:", current_active_code);
    
    // Check if the country code is valid (exists in the total_countries array)
    let countryCode = total_countries.includes(CountryCodeStatusZhash.toLowerCase()) 
                        ? CountryCodeStatusZhash.toLowerCase() 
                        : ''; // Default to "uk" if not found

    //console.log("Country Code Status:", CountryCodeStatusZhash);
    //console.log("Country Code:", countryCode);

    //console.log("currentPath:", currentPath);

    
    const matchedCountry = active_countries.find(code => currentPath.includes(`/${code}/`));
    //console.log(matchedCountry); // "eu"

    // Extract the current slug
    const getCurrentSlug = (path, countries) => {
      const pathSegments = path.split('/').filter(Boolean); // Split into segments and remove empty ones
      const filteredSegments = pathSegments.filter(segment => !countries.includes(segment)); // Exclude active countries
      const slug = filteredSegments[filteredSegments.length - 1]; // Get the last segment
      return slug && slug !== countries[countries.length - 1] ? slug : ""; // Return slug or empty if not valid
    };
    const currentSlug = getCurrentSlug(currentPath, active_countries);
    //console.log(currentSlug); // Output: "checkout" or "" if no valid slug exists

    // If current path already includes the country code, skip redirection
    if (currentPath.includes(`/${countryCode}/`) || currentPath === `/${countryCode}`) {
      //console.log(`URL already includes '/${countryCode}', skipping redirection.`);
      return; // Exit early if the URL already has the country code
    }

    


    //console.log("currentPath: ",currentPath);
    // Determine the appropriate country code based on the cookie or fallback
    //const pageSlugStore = currentSlug; //sessionStorage.getItem("pageSlug") || pageSlug;
    const pageSlugStore = currentSlug; //sessionStorage.getItem("pageSlug") || currentSlug;
    //console.log("page Slug Store", pageSlugStore);

    /*if(countryCode && countryCode !== matchedCountry && CountryCodeStatusZhash !== "Global"){

      const newPath = `/${currentSlug}`;
      const newUrl = `${base_url.replace(/\/$/, "")}${newPath}`;
      console.log("New Block !!");
      // window.location.replace(newUrl);

    }*/

    //if(currentPath === "/" && !base_url.includes("/uk") && !base_url.includes("/eu")){
      //window.location.replace(base_url);
    //}



    // If the URL doesn't contain the country code (i.e., it's the base URL or an invalid country code)
    if (!currentPath.includes("/uk/") && !currentPath.includes("/eu/")) {
      //console.log("No valid country code found in the URL. Redirecting...");

      
      if (pageSlugStore && CountryCodeStatusZhash !== "Global" && !currentPath.includes("/eu/") && base_url.includes("/eu")) {
        // Construct the new path based on country code and page slug
        //const newPath = `/${countryCode}/${pageSlugStore}`;
        const newPath = `/${pageSlugStore}`;
        //const newUrl = `${base_url.replace(/\/$/, "")}${newPath}${currentSearch}`;
        const newUrl = `${base_url.replace(/\/$/, "")}${newPath}`;

        //console.log("Redirecting to: newUrl EU", newUrl);
        window.location.replace(newUrl); // Perform the redirection
      }else if(pageSlugStore && CountryCodeStatusZhash !== "Global" && !currentPath.includes("/uk/") && base_url.includes("/uk")){
         // Construct the new path based on country code and page slug
         //const newPath = `/${countryCode}/${pageSlugStore}`;
         const newPath = `/${pageSlugStore}`;
         //const newUrl = `${base_url.replace(/\/$/, "")}${newPath}${currentSearch}`;
         const newUrl = `${base_url.replace(/\/$/, "")}${newPath}`;
 
         //console.log("Redirecting to: newUrl UK", newUrl);
         window.location.replace(newUrl); // Perform the redirection
      }else{
        if ((CountryCodeStatusZhash === "uk" && base_url.includes("/uk") && !currentPath.includes("/uk")) || 
            (CountryCodeStatusZhash === "eu"  && base_url.includes("/eu") && !currentPath.includes("/eu"))) {
            //console.log("Redirecting to 1st", base_url);
            window.location.replace(base_url);
        
            }else if (
              (CountryCodeStatusZhash === "uk" && base_url.includes("/uk") && currentPath.includes("/eu")) || 
              (CountryCodeStatusZhash === "uk" && base_url.includes("/uk") && currentPath.includes("/eu/")) ||
              (CountryCodeStatusZhash === "eu"  && base_url.includes("/eu") && !currentPath.includes("/uk")) ||
              (CountryCodeStatusZhash === "eu"  && base_url.includes("/eu") && !currentPath.includes("/uk/"))
            ) { //New added
            
            const newPath = `/${pageSlugStore}`;
            const newUrl = `${base_url.replace(/\/$/, "")}${newPath}${currentSearch}`;
           // console.log("Redirecting to 1st New Added", newUrl);
            window.location.replace(newUrl);
        
        } else {
            //console.log("Redirecting to 2nd");
        }
        //console.log("Redirecting to: base_url", base_url);
        //window.location.replace(base_url); // Perform the redirection
      }
    
    }else if ((CountryCodeStatusZhash === "Global" && !base_url.includes("/uk") && currentPath.includes("/uk")) || 
      (CountryCodeStatusZhash === "Global"  && !base_url.includes("/eu") && currentPath.includes("/eu"))) {
        //console.log("Else Part", base_url);
        window.location.replace(base_url);
        //window.location.reload();
      
    }
  }, []);

  return null; // This component doesn't render anything 
  
};

export default UrlRedirector;
